import { VisitConfigCreate } from '@dynamika-shared/types/visits';
import { RESTClient } from '@api/client';

export const createVisit = (ctId: string, visits: VisitConfigCreate[]) => {
    return RESTClient.post(`clinical-trials/${ctId}/visits`, { visits });
};
export const deleteVisit = (ctId: string, visitId: string) => {
    return RESTClient.delete(`clinical-trials/${ctId}/visits/${visitId}`);
};
export const updateVisit = (ctId: string, visitId: string, visit: VisitConfigCreate) => {
    return RESTClient.put(`clinical-trials/${ctId}/visits/${visitId}`, visit);
};
